const reportReviewEN = {
	title: "Report Review",
	subtitle: "Why are you reporting this review?",
	reason: {
		spam: "Spam or fake",
		inappropriate: "Inappropriate or offensive",
		harassment: "Harassment or bullying",
		incorrect: "Incorrect information",
		other: "Other",
	},
	placeholder: "Add more details (optional)",
	adminSubtitle: "Describe why you are reporting this review (optional).",
	adminPlaceholder: "Additional details (optional)",

	actions: {
		selectReason: "Select a reason",
		selectReasonError: "Please select a reason before submitting.",
		cancel: "Cancel",
		submit: "Submit Report",
		submitting: "Submitting...",
		success: "Thanks! Your report has been submitted.",
		error: "We couldn't submit your report. Please try again.",
		emailPlaceholder: "Your email (optional)",
	},
};

export default reportReviewEN;
